export var otpLengthPropType = function (props) {
    var allowedValues = [4, 6, 8];
    if (props.otpLength !== undefined &&
        !allowedValues.includes(props.otpLength)) {
        return new Error("Invalid prop 'otpLength' supplied to 'InputOtp'. Expected one of " + allowedValues.join(', ') + ", but received " + props.otpLength + ".");
    }
    return null;
};
//# sourceMappingURL=InputOtp.utils.js.map